import React, { FC, ReactNode } from 'react';
import { WithTranslation } from 'react-i18next';
import { InlineMessageProps } from '../InlineMessage';

import { StyledInlineMessage } from './NoDataMessage.styles';

export interface NoDataMessageProps extends InlineMessageProps {
  /** Content of the message. */
  children?: ReactNode;
}

const NoDataMessage: FC<NoDataMessageProps & WithTranslation> = ({ t, tReady, i18n, children, ...props }) => (
  <StyledInlineMessage {...props}>{ children || t('noDataMessage')}</StyledInlineMessage>
);

export default NoDataMessage;
